<style>
.el-form-item--mini .el-form-item__error {
  margin-top: -10px!important;
}
</style>
<template>
  <div>
    <div style="margin-top: 10px;display:flex;justify-content:center;align-items:center">
      <div style="width: 74%;border: 1px solid #13305D;margin-bottom: 10px">

        <el-form :model="ruleForm"  :rules="rules" ref="ruleForm"  class="demo-ruleForm" label-width="150px" size="mini">
          <el-row :gutter="1">
            <div style="border-bottom: 1px solid #13305D;margin-bottom: 10px">
              <p style="margin-left:20px;margin-top: 0px;margin-bottom: 5px;color: #13305D;font-weight: bold;text-align: center">Submission Form</p>
            <p style="font-size:1rem;margin-top: 0px;margin-left:20px;margin-bottom: 0px ;">It is inevitable that the collections of RNAPhaSep may not cover all RNA associated phase separation. So we provide the submission interface to make sure that researchers can submit new items that are not documented. Please fulfill the information following as much as possible, which can help us ingest your data correctly.</p>
              <p style="font-size:1rem;margin-top: 0px;margin-left:20px;margin-bottom: 0px ">If your data contains more than one RNA or protein , please use ";" to keep them apart.</p>
              <p style="font-size:1rem;margin-top: 0px;margin-left:20px;margin-bottom: 10px ">Thanks for your contribution to RNAPhaSep!</p>
            </div>

          </el-row>
              <el-row :gutter="1" type="flex" class="row-bg" justify="center">
                <el-col :xs="11" :sm="11" :md="11" :lg="8" :xl="8" >
                  <el-form-item label="Your name" prop="name"  required>
                    <el-input v-model="ruleForm.name"></el-input>
                  </el-form-item>

                  <el-form-item label="Data source" prop="Data_source"  required>
                    <el-select v-model="ruleForm.Data_source">
                      <el-option label="Published" value="Published"></el-option>
                      <el-option label="Preprint" value="Preprint"></el-option>
                      <el-option label="Unpublished" value="Unpublished"></el-option>

                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :xs="11" :sm="11" :md="11" :lg="8" :xl="8" >
                  <el-form-item label="Email" prop="Email"  required >
                    <el-input v-model="ruleForm.Email"></el-input>
                  </el-form-item>

                  <el-form-item label="PMID or preprint link" prop="Pmid">
                    <el-input v-model.number="ruleForm.Pmid"></el-input>
                  </el-form-item>

                </el-col>
              </el-row>
          <el-row>
            <p style="font-size:18px;margin-top: 0px;margin-left: 100px;color: #13305D;font-weight: bold">RNA and protein:</p>
          </el-row>
              <el-row :gutter="1" type="flex" class="row-bg" justify="center">

                <el-col :xs="11" :sm="11" :md="11" :lg="8" :xl="8" >



                  <el-form-item label="RNA" prop="Rna"  required>
                    <el-input v-model="ruleForm.Rna"></el-input>
                  </el-form-item>

                  <el-form-item label="RNA length" prop="RNA_length">
                    <el-input v-model="ruleForm.RNA_length"></el-input>
                  </el-form-item>

                  <el-form-item label="RNA type" prop="RNA_classification" required>
                    <el-input v-model="ruleForm.RNA_classification"></el-input>
                  </el-form-item>

                  <el-form-item label="RNA species" prop="RNA_source" required>
                    <el-input v-model="ruleForm.RNA_source"></el-input>
                  </el-form-item>

                  <el-form-item label="RNA description" prop="RNA_description">
                    <el-input v-model="ruleForm.RNA_description"></el-input>
                  </el-form-item>

                  <el-form-item label="RNA sequence" prop="RNA_sequence">
                    <el-input type="textarea" v-model="ruleForm.RNA_sequence"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="11" :sm="11" :md="11" :lg="8" :xl="8">


                  <el-form-item label="Protein" prop="protein" >
                    <el-input v-model="ruleForm.protein"></el-input>
                  </el-form-item>

                  <el-form-item label="Protein mutation" prop="Mutation" >
                    <el-input v-model="ruleForm.Mutation"></el-input>
                  </el-form-item>
                  <el-form-item label="Protein PTM" prop="PTM" >
                    <el-input v-model="ruleForm.protein"></el-input>
                  </el-form-item>
                  <el-form-item label="Protein cleaved" prop="Cleaved" >
                    <el-input v-model="ruleForm.Cleaved"></el-input>
                  </el-form-item>
                  <el-form-item label="Protein length" prop="Length" >
                    <el-input v-model="ruleForm.Length"></el-input>
                  </el-form-item>
                  <el-form-item label="Protein sequence" prop="Sequence" >
                    <el-input type="textarea" v-model="ruleForm.Sequence"></el-input>
                  </el-form-item>

                </el-col>
              </el-row>
          <el-row>
            <p style="font-size:18px;margin-top: 0px;margin-left: 100px;color: #13305D;font-weight: bold">Experiment elements:</p>
          </el-row>
              <el-row :gutter="1" type="flex" class="row-bg" justify="center">

                <el-col :xs="11" :sm="11" :md="11" :lg="8" :xl="8"  >

                  <el-form-item label="Solute concentration" prop="Solute_concentration">
                    <el-input v-model="ruleForm.Solute_concentration"></el-input>
                  </el-form-item>

                  <el-form-item label="Buffer" prop="Buffer">
                    <el-input v-model="ruleForm.Buffer"></el-input>
                  </el-form-item>

                  <el-form-item label="Incubation time" prop="Incubation_time">
                    <el-input v-model="ruleForm.Incubation_time"></el-input>
                  </el-form-item>


                  <el-form-item label="Vivo/Vitro" prop="Vivo_or_vitro"  required>
                    <el-radio-group v-model="ruleForm.Vivo_or_vitro">
                      <el-radio label="Vivo"></el-radio>
                      <el-radio label="Vitro"></el-radio>
                    </el-radio-group>
                  </el-form-item>

                </el-col>

                <el-col :xs="11" :sm="11" :md="11" :lg="8" :xl="8">

                  <el-form-item label="Salt concentration" prop="Salt_concentration">
                    <el-input v-model="ruleForm.Salt_concentration"></el-input>
                  </el-form-item>

                  <el-form-item label="Temperature" prop="Temperature">
                    <el-input v-model="ruleForm.Temperature"></el-input>
                  </el-form-item>

                  <el-form-item label="Detection method" prop="Detection_method"  required>
                    <el-input v-model="ruleForm.Detection_method"></el-input>
                  </el-form-item>

                  <el-form-item label="Other requirement" prop="Other_requirement" >
                    <el-input v-model="ruleForm.Other_requirement"></el-input>
                  </el-form-item>


                </el-col>

              </el-row>


          <el-row>
            <p style="font-size:18px;margin-top: 0px;margin-left: 100px;color: #13305D;font-weight: bold">Conclusion:</p>
          </el-row>
          <el-row :gutter="1" type="flex" class="row-bg" justify="center">

            <el-col :xs="11" :sm="11" :md="11" :lg="8" :xl="8"  >


              <el-form-item label="Phase separation" prop="ps"  required>
                <el-radio-group v-model="ruleForm.ps">
                  <el-radio label="Yes"></el-radio>
                  <el-radio label="No"></el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="Morphology" prop="Morphology"  required>
              <el-select v-model="ruleForm.Morphology">
                <el-option label="Solute" value="Solute"></el-option>
                <el-option label="Liquid" value="Liquid"></el-option>
                <el-option label="Gel" value="Gel"></el-option>
                <el-option label="Solid" value="Solid"></el-option>
              </el-select>
              </el-form-item>
            </el-col>

            <el-col :xs="11" :sm="11" :md="11" :lg="8" :xl="8">

              <el-form-item label="Description" prop="Description" >
                <el-input type="textarea" v-model="ruleForm.Description"></el-input>
              </el-form-item>

            </el-col>

          </el-row>


        </el-form>
        <div style="display:flex;justify-content:center;align-items:center;margin-bottom: 10px">
        <el-button type="primary" size="small" @click="submitForm('ruleForm')">Submit</el-button>
        <el-button size="small" type="danger" @click="resetForm('ruleForm')">Reset</el-button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {submit} from "@/network/submit";

export default {
  name: "Submit",
  data() {
    return {
      ruleForm: {
        name:'',
        Email:'',

        Pmid:'',
        Rna:'',
        RNA_length:'',
        RNA_splicing:'',
        RNA_classification:'',
        RNA_source:'',
        RNA_description:'',
        RNA_sequence:'',
        protein:'',
        Mutation:'',
        PTM:'',
        Cleaved:'',
        Data_source: '',
        Length:'',
        Sequence:'',
        ps:'',
        Solute_concentration:'',
        Buffer:'',
        Salt_concentration:'',
        Temperature:'',
        Incubation_time:'',
        Detection_method:'',
        Morphology:'',
        Vivo_or_vitro:'',
        Description:'',
        Other_requirement:''

      },
      rules: {
        name: [
          { required: true, message: 'Please enter your name', trigger: 'blur' }
        ],
        Email: [
          { required: true, message: 'Your email is required', trigger: 'blur' },
          {type:'email',message: 'Please enter the correct email address',trigger: ['blur']}
        ],
        Data_source: [
          { required: true, message: 'Select Component type', trigger: 'blur' }
        ],
        Rna: [
          { required: true, message: 'Please enter RNA', trigger: 'blur' }
        ],
        RNA_classification: [
          { required: true, message: 'Please enter RNA type', trigger: 'blur' }
        ],
        RNA_source: [
          { required: true, message: 'Please enter RNA source', trigger: 'blur' }
        ],

        Detection_method: [
          { required: true, message: 'Detection method is required', trigger: 'blur' }
        ],
        Vivo_or_vitro: [
          { required: true, message: 'Please select', trigger: 'blur' }
        ],
        ps: [
          { required: true, message: 'Please select', trigger: 'blur' }
        ],

      }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$message({
            message: 'Success! Thanks for your submission!',
            type: 'success'
          });
          submit(this.ruleForm);
          this.$refs[formName].resetFields();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>
<style scoped>
.el-input{
  max-width: 180px;
}
.el-select{
  max-width: 180px;
}
.el-textarea{
  max-width: 180px;
}

</style>